import {Types} from "../actions/courseActions";
import _ from 'lodash';

const courseReducers = (state, action) => {
    switch(action.type) {
        case Types.COURSES_WEBINAR_ATTENDANCE_FILE_NAME: {
            let newState = _.cloneDeep(state);
            newState.courseWebinarAttendanceImport.fileName = action.fileName;
            newState.courseWebinarAttendanceImport.processingFile = true;

            return newState;
        }
        case Types.COURSES_WEBINAR_ATTENDANCE_DATA_LOADED: {

            let newState = _.cloneDeep(state);

            newState.courseWebinarAttendanceImport.processingFile = false;
            newState.courseWebinarAttendanceImport.fields = action.fields;
            newState.courseWebinarAttendanceImport.data = action.data;
            newState.courseWebinarAttendanceImport.dataToSend = false;

            return newState;
        }
        case Types.COURSES_CHANGE_WEBINAR_ATTENDEE_NAME: {

            let newState = _.cloneDeep(state);
            const attendeeToChange = newState.courseWebinarAttendanceImport.data[action.index]
            attendeeToChange["First Name"] = action.attendeeName;
            attendeeToChange["Last Name"] = action.attendeeSurname;

            return newState;
        }
        case Types.COURSES_CHANGE_WEBINAR_ATTENDEE_EMAIL: {

            let newState = _.cloneDeep(state);
            const attendeeToChange = newState.courseWebinarAttendanceImport.data[action.index]
            attendeeToChange["Email"] = action.attendeeEmail;

            return newState;
        }
        case Types.COURSES_SET_WEBINAR_ATTENDEE_CERTIFICATE_STATUS: {

            let newState = _.cloneDeep(state);
            const attendeeToChange = newState.courseWebinarAttendanceImport.data[action.index]
            attendeeToChange["Certificate Status"] = action.status;

            return newState;
        }
        case Types.COURSES_ADD_NEW_ATTENDEE: {

            let newState = _.cloneDeep(state);
            if (!newState.courseWebinarAttendanceImport?.data?.length) newState.courseWebinarAttendanceImport.data = [];
            newState.courseWebinarAttendanceImport.data.push({
                "First Name": "First Name",
                "Last Name": "Last Name",
                "Email": "Email",
                "Certificate Status": false
            })

            return newState;
        }
        case Types.COURSES_SET_ALL_CERTIFICATES_STATUS: {

            let newState = _.cloneDeep(state);
            newState.courseWebinarAttendanceImport.data.forEach((attendee) => {
                attendee["Certificate Status"] = action.status;
            })

            return newState;
        }

        default: return state;
    }
}

export default courseReducers;